import { makeExactRegexp } from './regularExpression'

/*
  Accept URLs as:
    > https://local.lan
    > https://local.lan:5000
    > https://local.lan:5000/subfolder/image.png
    > https://local.lan:5000?query=select * from table
    > https://192.168.1.1
    > https://192.168.1.1:3001
    > https://192.168.1.1:3001/subfolder/image.png
    > www.example.com
*/
export const WEB_URL_SEARCH_REGEXP = /(https?:\/\/|www\.)[\w.-]+(?:\.[a-z]{2,})?(?::\d{1,5})?(\/[^\s]*)?/i
export const WEB_URL_EXACT_REGEXP = makeExactRegexp(WEB_URL_SEARCH_REGEXP)

export function isValidURL(url: string) {
  return WEB_URL_EXACT_REGEXP.test(url)
}

export function isValidHttpURL(url: string) {
  const uriRegex = /^(https?):\/\/[^\s/$.?#].[^\s]*(\?[^\s]*=?.*&?)*$/
  return uriRegex.test(url)
}
